import _ from 'lodash';
import React, { Component } from 'react';import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as accounts_actions from 'data/accounts/actions';
import * as users_actions from 'data/users/actions';
import MenuLink  from 'components/Navigation/MenuLink';
import Delete  from 'components/Buttons/Delete';

import { Page, PageBlock, RightDrawer } from 'components/Page';

import ModeEdit from 'material-ui/svg-icons/editor/mode-edit';
import Subheader from 'material-ui/Subheader';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow} from 'material-ui/Table';
import ClickableRowColumn from 'components/Grid/ClickableRowColumn';
import ClickableRow from 'components/Grid/ClickableRow'


class AccountList extends Component {
  state = {  };

  static contextTypes = {
    router: PropTypes.object
  };

  componentWillMount() {
    this.props.actions.fetchAccounts();
    this.props.actions.fetchUsers();
  }

  handleDeleteClick(id) {
    this.props.actions.deleteAccount(id);
  }

  handleEditClick(id) {
    this.context.router.history.push("/admin/account/"+id);
  }

  renderAccounts() {
    const accounts = this.props.accounts
    if (!accounts || accounts.length === 0)
    {
      return null;
    }
    return _.map(accounts, (account, key) => {
      var admin = account.admins && account.admins.info ? account.admins.info.email : ''
      return (
        <ClickableRow key={key} onMyRowClick={ () => this.handleEditClick(key)}>
          <ClickableRowColumn>{account.orgname}</ClickableRowColumn>
          <ClickableRowColumn>{account.orgphone}</ClickableRowColumn>
          <ClickableRowColumn>{account.orgemail}</ClickableRowColumn>
          <ClickableRowColumn>{admin}</ClickableRowColumn>
          
        </ClickableRow>
      );
    });
  }
  
  render() {
    return [
      <RightDrawer key="right">
        <PageBlock label="Konton">
        
        </PageBlock>
      </RightDrawer>,
      <Page key="page"   ready={!this.props.pending}>
       
        <Table>
          <TableHeader>
            <TableRow>
              <TableHeaderColumn>Namn</TableHeaderColumn>
              <TableHeaderColumn>Telefonnummer</TableHeaderColumn>
              <TableHeaderColumn>E-post</TableHeaderColumn>
              <TableHeaderColumn>Admin</TableHeaderColumn>
              <TableHeaderColumn></TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody>
            {this.renderAccounts()}
          </TableBody>
        </Table>
        
      </Page>
    ]
  }
}

function mapStateToProps(state) {
  if (!state.accounts) return {};
  var accounts = {};
  for (var aid in state.accounts.list )
  {
    var a = state.accounts.list[aid]
    if (a.admin)
    {
      a.admins = state.users.list[a.admin]
    }
    accounts[aid] = a;
  }
  return {
    accounts: accounts,
    pending: !accounts,
  };
}

const mapDispatch = (dispatch) => {
    return {
        actions: bindActionCreators({...accounts_actions , ...users_actions }, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatch)(AccountList)


// WEBPACK FOOTER //
// ./src/pages/admin/accounts/AccountList.jsx